import { useLayoutEffect, useState } from "react"

import Event from "./event/event"
import Help from "./help/help"
import Schedule from "./schedule/schedule"
import Register from "./register/register"
import Status from "./status/status"
import Notice from "./notice/notice"
import Menu from "./menu/menu"

import cmathStyle from "./cmath.module.css"

import { useLoaderData, useLocation } from "react-router"
import { get_grade_list } from "consumer/@@@/get_grade_list"
import { useOffcanvas } from "offcanvas/provider"


const today = new Date()
today.setHours(0, 0, 0, 0)
const todayYear = today.getFullYear()
const todayMonth = today.getMonth()
const todayDate = today.getDate()
const todayWeek = today.getDay()


export default function Cmath() {

    const location = useLocation()
    const loaderData = useLoaderData()

    const { offcanvas_close } = useOffcanvas()

    const [branchInfo, Set_branchInfo] = useState({
        'id': loaderData['BranchID'],
        'name': loaderData['BranchName']
    })
    const [gradeList, Set_gradeList] = useState([])

    const [eventList, Set_eventList] = useState([])
    const [selectEevent, Set_selectEvent] = useState(null)

    const [searchYear, Set_searchYear] = useState(null)
    const [searchMonth, Set_searchMonth] = useState(null)

    const [firstDay, Set_firstDay] = useState(null)
    const [lastDay, Set_lastDay] = useState(null)
    const [selectDay, Set_selectDay] = useState([])

    const [monthSchedule, Set_monthSchedule] = useState(null)

    const [statusToggle, Set_statusToggle] = useState(false)
    const [statusList, Set_statusList] = useState(null)

    const [selectTab, Set_selectTab] = useState(0)

    const [screenWidth, Set_screenWidth] = useState(window.innerWidth)
    const [screenHeight, Set_screenHeight] = useState(window.innerHeight)

    window.EventManager = {
        today: today,
        todayYear: todayYear,
        todayMonth: todayMonth,
        todayDate: todayDate,
        todayWeek: todayWeek,

        branchInfo: branchInfo,
        Set_branchInfo: Set_branchInfo,

        gradeList: gradeList,
        Set_gradeList: Set_gradeList,

        eventList: eventList,
        Set_eventList: Set_eventList,
        selectEevent: selectEevent,
        Set_selectEvent: Set_selectEvent,

        searchYear: searchYear,
        Set_searchYear: Set_searchYear,
        searchMonth: searchMonth,
        Set_searchMonth: Set_searchMonth,
        firstDay: firstDay,
        Set_firstDay: Set_firstDay,
        lastDay: lastDay,
        Set_lastDay: Set_lastDay,
        selectDay: selectDay,
        Set_selectDay: Set_selectDay,

        monthSchedule: monthSchedule,
        Set_monthSchedule: Set_monthSchedule,

        statusToggle: statusToggle,
        Set_statusToggle: Set_statusToggle,
        statusList: statusList,
        Set_statusList: Set_statusList
    }

    useLayoutEffect(() => {
        document.body.classList.add(cmathStyle['body'])

        window.addEventListener("contextmenu", function(e) {
            e.preventDefault()
        })

        window.addEventListener("resize", function() {
            Set_screenWidth(window.innerWidth)
            Set_screenHeight(window.innerHeight)
        })

        window.addEventListener("keydown", function(e) {
            if(e['key'] === 'Escape') {
                offcanvas_close()
            }
        })

        // 학년 목록 불러오기
        get_grade_list({
            Set_gradeList: Set_gradeList
        })
    }, [])

    return(
        <div
            className={cmathStyle['cmathWrap']}
            style={{
                width: screenWidth,
                height: screenHeight
            }}
        >
            <div className={cmathStyle['leftMenu']}>
                <Menu
                    selectTab={selectTab}
                    Set_selectTab={Set_selectTab}
                ></Menu>
            </div>

            <div
                className={cmathStyle['contentWrap']}
                style={{
                    display: selectTab === 0 ? "block" : "none"
                }}
            >
                <div className={cmathStyle['contentTop']}>
                    <Event></Event>

                    <Help></Help>
                </div>

                <div className={cmathStyle['contentBottom']}>
                    <Schedule></Schedule>

                    {selectEevent !== null &&
                    <>
                        <Register></Register>

                        <Status></Status>
                    </>
                    }
                </div>
            </div>

            <div
                className={cmathStyle['contentWrap']}
                style={{
                    display: selectTab === 1 ? "block" : "none"
                }}
            >
                <div className={cmathStyle['contentTop']}>
                    <Notice></Notice>
                </div>
            </div>
        </div>
    )
}